import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './index.css';
import { client } from './client/client.gen';
import { AppContextProvider } from './AppContext';
import { App } from './App';

const queryClient = new QueryClient();

client.setConfig({ baseURL: import.meta.env.VITE_API_URL ?? 'http://localhost:8000' });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AppContextProvider>
          <App />
        </AppContextProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
